import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductionProgress } from '@/components/ProductionProgress';
import { useProductWorkflow } from '@/hooks/useProductWorkflow';

export function ProductionPage() {
  const navigate = useNavigate();
  const { productionStatus, productionProgress, currentProduct } = useProductWorkflow();

  useEffect(() => {
    if (productionStatus === 'COMPLETED' && currentProduct) {
      navigate(`/products/${currentProduct.id}`);
    }
  }, [productionStatus, currentProduct, navigate]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold mb-2">Production in Progress</h2>
        <p className="text-muted-foreground">
          Your product is being processed through the production line
        </p>
      </div>
      <ProductionProgress
        status={productionStatus}
        progress={productionProgress}
      />
    </div>
  );
}
